import { Polygon } from "leaflet";
import { HidroLayer, HidroLayerGroup } from "./layers";
import { PolyZas, PolyZss } from "../zas";
import { PolyMancha } from "../barragem";
import { LayerGroup } from "leaflet";
import { Polyline } from "leaflet";

export function getPolygon(layers: (HidroLayer | HidroLayerGroup)[], multipolygon?: boolean): HidroLayer | undefined {
  for (const layer of layers) {
    if (layer instanceof HidroLayerGroup) {
      const lay = getPolygon(layer.layers, multipolygon);
      if (lay) return lay;
      continue;
    }

    if (layer.layer instanceof Polygon || layer.layer instanceof PolyZas || layer.layer instanceof PolyZss || layer.layer instanceof PolyMancha) {
      return layer;
    }

    if (multipolygon && layer.layer instanceof LayerGroup) {
      const polys = layer.layer.getLayers().filter(lay => lay instanceof Polygon);
      if (polys.length === 0) continue;

      return new HidroLayer({
        name: layer.name,
        showing: layer.showing,
        style: layer.style,
        properties: layer.properties,
        actions: layer.actions,
        layer: new LayerGroup(polys),
      });
    }
  }

  return undefined;
}

export function getLineStrings(layers: (HidroLayer | HidroLayerGroup)[]): HidroLayer[] {
  const polylines: HidroLayer[] = [];
  for (const layer of layers) {
    if (layer instanceof HidroLayerGroup) {
      const lay = getLineStrings(layer.layers);
      if (lay.length > 0) {
        lay.forEach(l => polylines.push(l));
      }
      continue;
    }
    if (layer.layer instanceof Polygon) continue;

    if (layer.layer instanceof Polyline) {
      polylines.push(layer);
    }
  }

  return polylines;
}